import React, { useContext, useState, useEffect } from 'react';
import context from '../context';
import styled from 'styled-components';
import Link from '../components/link';
import Logo from './logo';
import { NavLink as BaseNavLink } from '../styled-components';
import {
  MenuOutlined,
  CloseOutlined,
  FacebookOutlined,
  InstagramOutlined,
  WhatsAppOutlined,
  MailOutlined,
} from '@ant-design/icons';

const MobileHeaderWrapper = styled.div`
  @media(min-width: 992px) { display: none; }
`;

const MobileHeader = styled.header`
  background-color: #fff;
  position: fixed;
  top: ${props => (props.hidden ? '-100px' : '2px')};
  left: 0;
  z-index: 1050;
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex; align-items: center; justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0,0,0,.1);
  transition: top .5s cubic-bezier(.4,0,.2,1), opacity .5s ease-in-out;
  opacity: ${props => (props.hidden ? 0 : 1)};
`;

const NavDrawer = styled.nav`
  position: fixed; top: 0;
  right: ${props => (props.open ? '0' : '-100%')};
  width: 80%; height: 100%; background: #fff; z-index: 1100;
  transition: right .3s ease-in-out; padding: 2rem 1.5rem;
  box-shadow: -2px 0 8px rgba(0,0,0,.1);
  display: flex; flex-direction: column; justify-content: space-between;
`;

const NavList = styled.ul`
  list-style: none; padding: 0; margin: 2rem 0;
`;

const NavItem = styled.li`
  margin-bottom: 1.2rem;
`;

const NavLink = styled(BaseNavLink)`
  color: #000; font-weight: 700; text-transform: uppercase;
  font-size: .95rem; text-decoration: none;
`;

const IconButton = styled.button`
  background: none; border: none; font-size: 1.5rem;
`;

const SocialLinks = styled.div`
  display: flex; justify-content: space-around; margin-top: 3rem;
  a { color:#000; font-size:1.5rem; transition: color .2s; }
  a:hover { color: ${p => p.theme.primaryColor}; }
`;

export default () => {
  const state = useContext(context);
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const current = window.pageYOffset;
      setHidden(current > lastScroll && current > 60);
      setLastScroll(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScroll]);

  return (
    <MobileHeaderWrapper>
      <MobileHeader hidden={hidden}>
        <Link to="/"><Logo /></Link>
        <IconButton onClick={() => setOpen(true)} aria-label="Abrir menú">
          <MenuOutlined />
        </IconButton>
      </MobileHeader>

      <NavDrawer open={open}>
        <div>
          <IconButton onClick={() => setOpen(false)} style={{ marginLeft: 'auto', display: 'block' }} aria-label="Cerrar menú">
            <CloseOutlined />
          </IconButton>
          <NavList>
            <NavItem>
              <Link to="/about" onClick={() => setOpen(false)}>
                <NavLink>NOSOTROS</NavLink>
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/properties" onClick={() => setOpen(false)}>
                <NavLink>GESTIÓN INMOBILIARIA</NavLink>
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/temporalrent" onClick={() => setOpen(false)}>
                <NavLink>ARRIENDOS TEMPORALES</NavLink>
              </Link>
            </NavItem>

            {/* 👇 Nuevo ítem BLOG */}
            <NavItem>
              <Link to="/blog" onClick={() => setOpen(false)}>
                <NavLink>BLOG</NavLink>
              </Link>
            </NavItem>

            <NavItem>
              <Link to="/contact" onClick={() => setOpen(false)}>
                <NavLink>INVERSIONISTAS</NavLink>
              </Link>
            </NavItem>
          </NavList>
        </div>

        <SocialLinks>
          <a href="https://facebook.com" target="_blank" rel="noreferrer"><FacebookOutlined /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer"><InstagramOutlined /></a>
          <a href="https://wa.me/56912345678" target="_blank" rel="noreferrer"><WhatsAppOutlined /></a>
          <a href="mailto:contacto@tudominio.cl"><MailOutlined /></a>
        </SocialLinks>
      </NavDrawer>
    </MobileHeaderWrapper>
  );
};